import _ from "lodash";

import { NiceMenu } from "../Helpers/NiceMenu";
import { AppContext } from "@/AppContext";
import ListItem from "@/ui/_old/ListItem";


export const DownloadFile = (props) => {
    const { action, updateAction } = props;
    const { payload } = action;

    return (
        <AppContext.Consumer>
            {({ app }) => (
                // show dropdown menu of files
                <NiceMenu
                    style={{ marginTop: 10 }}
                    label={_.get(payload, "urlFileName", "Choose a file...")}
                >
                    <ListItem
                        icon="link"
                        onClick={() => {
                            const urlPrompt = window.prompt(
                                "Enter the url to the file you want downloaded",
                                _.get(payload, "url", "http://")
                            );

                            if (urlPrompt) {
                                const url = urlPrompt.indexOf("http") > -1
                                    ? urlPrompt
                                    : `http://${urlPrompt}`;

                                updateAction(
                                    action,
                                    {
                                        url,
                                        urlFileName: url,
                                        useTag: false,
                                    },
                                    { href: url }
                                );
                            }
                        }}
                    >
                        Enter a Custom URL
                    </ListItem>
                </NiceMenu>
            )}
        </AppContext.Consumer>
    );
};
